module.exports = __webpack_public_path__ + "static/media/trevo_pin.6c6642db.png";